// extracted by mini-css-extract-plugin
export default {"container":"SuggestedProgram_container__dvdo6","h2":"SuggestedProgram_h2__8YMML","noresult":"SuggestedProgram_noresult__CFMlA"};